<script>
import ErrorMessage from '@/Components/Forms/ErrorMessage'
import BlueButton from '@/Components/Buttons/BlueButton'
export default {
    components: {
        ErrorMessage,
        BlueButton
    },
    props: {
        accept: {
            type: String,
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: [Array, String]
        },
        placeholder: {
            type: Array
        },
        containerClasses: {
            type: String,
            default: ''
        },
        dragAreaClasses: {
            type: String,
            default: ''
        },
        resetOnUpload: {
            type: Boolean,
            default: false
        },
        draggable: {
            type: Boolean,
            default: true
        },
        displayPreview: {
            type: Boolean,
            default: true
        },
        displayErrors: {
            type: Boolean,
            default: true
        },
        duskSelector: {
            type: String,
            default: 'fileInput'
        }
    },
    emits: ['update:modelValue', 'errors'],
    data() {
        return {
            active: false,
            inactiveTimeout: null,
            events: ['dragenter', 'dragover', 'dragleave', 'drop'],
            files: [],
            fileErrors: []
        }
    },
    computed: {
        fileTypes() {
            let types = []
            this.accept.split(',').forEach(item => {
                switch (item) {
                case 'image/*':
                    types.push(...['.jpg', '.jpeg', '.png', '.gif'])
                    break
                case 'application/pdf':
                    types.push('.pdf')
                    break
                case 'application/msword':
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    types.push(...['.doc', '.docx'])
                    break
                case 'application/vnd.ms-excel':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    types.push(...['.xls', '.xlsx'])
                    break
                case 'application/vnd.ms-powerpoint':
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                    types.push(...['.ppt', '.pptx'])
                    break
                case 'text/plain':
                    types.push('.txt')
                    break
                case 'application/zip':
                    types.push('.zip')
                    break
                default:
                    types.push(item)
                }
            })
            return types
        },
        fileIcons() {
            let icons = []
            this.fileTypes.forEach(type => {
                switch (type) {
                case '.jpg':
                case '.jpeg':
                case '.png':
                case '.gif':
                    icons.indexOf('file-image') === -1 ? icons.push('file-image') : null
                    break
                case 'video/*':
                case '.mp4':
                case '.mov':
                case '.avi':
                case '.wmv':
                    icons.indexOf('file-video') === -1 ? icons.push('file-video') : null
                    break
                case 'application/pdf':
                case '.pdf':
                    icons.indexOf('file-pdf') === -1 ? icons.push('file-pdf') : null
                    break
                case '.doc':
                case '.docx':
                    icons.indexOf('file-word') === -1 ? icons.push('file-word') : null
                    break
                case '.xls':
                case '.xlsx':
                    icons.indexOf('file-excel') === -1 ? icons.push('file-excel') : null
                    break
                case '.ppt':
                case '.pptx':
                    icons.indexOf('file-powerpoint') === -1 ? icons.push('file-powerpoint') : null
                    break
                case '.zip':
                case '.rar':
                case '.7z':
                    icons.indexOf('file-archive') === -1 ? icons.push('file-archive') : null
                    break
                case '.mp3':
                    icons.indexOf('file-music') === -1 ? icons.push('file-music') : null
                    break
                default:
                    icons.indexOf('file-alt') === -1 ? icons.push('file-alt') : null
                    break
                }
            })
            return icons
        }
    },
    mounted() {
        if (this.placeholder && Array.isArray(this.placeholder)) {
            this.files = [...this.placeholder]
        }
        this.events.forEach(eventName => {
            document.body.addEventListener(eventName, this.preventDefaults)
        })
    },
    unmounted() {
        this.events.forEach(eventName => {
            document.body.removeEventListener(eventName, this.preventDefaults)
        })
    },
    methods: {
        onDrop(e) {
            if (this.draggable) {
                this.setInactive()
                this.files = this.multiple
                    ? [...e.dataTransfer.files]
                    : [e.dataTransfer.files[0]]
                this.fileErrors = []
                this.$emit('errors', this.fileErrors)
                this.validateFiles()
                this.$emit('update:modelValue', this.files)
                if (this.resetOnUpload) {
                    this.resetFileInput()
                }
            }
        },
        preventDefaults(e) {
            e.preventDefault()
        },
        setActive() {
            if (this.draggable) {
                this.active = true
                clearTimeout(this.inactiveTimeout)
            }
        },
        setInactive() {
            if (this.draggable) {
                this.inactiveTimeout = setTimeout(() => {
                    this.active = false
                }, 50)
            }
        },
        chooseFiles(e) {
            if(['div', 'ul', 'button'].includes(e.target.tagName.toLowerCase())) {
                this.$refs.fileInput.click()
            }
        },
        selectFiles() {
            let fileInput = this.$refs.fileInput
            let files = fileInput.files
            if (files && files[0]) {
                this.files = this.multiple ? [...files] : [files[0]]
                this.fileErrors = []
                this.$emit('errors', this.fileErrors)
                this.validateFiles()
                this.$emit('update:modelValue', this.files)
                if (this.resetOnUpload) {
                    this.resetFileInput()
                }
            }
        },
        removeFile(e, index) {
            e.stopPropagation()
            this.files.splice(index, 1)
            this.$emit('update:modelValue', this.files)
        },
        showImage(img) {
            if (typeof img == 'object') {
                if (img.path) {
                    return img.path
                }
                return URL.createObjectURL(img)
            }
            return false
        },
        validateFiles() {
            this.files = this.files.filter(file => {
                const fileExt = '.' + file.name.split('.').pop()
                if (this.fileTypes.indexOf(file.type) < 0 && this.fileTypes.indexOf(fileExt) < 0) {
                    file.errorType = 'type'
                    this.fileErrors.push(file)
                    return false
                } else if (file.size < 1) {
                    file.errorType = 'size'
                    this.fileErrors.push(file)
                    return false
                } else {
                    return true
                }
            })
            this.$emit('errors', this.fileErrors)
        },
        resetFileInput() {
            this.files = []
            if (this.placeholder && Array.isArray(this.placeholder)) {
                this.files = [...this.placeholder]
            }
        }
    }
}
</script>

<template>
    <div class="flex flex-col flex-1 h-full">
        <div
            class="group flex relative flex-col flex-1 w-full h-full rounded cursor-pointer"
            :data-active="active"
            :class="[containerClasses, {'border-4 border-dashed border-rss-button-blue-900': active}]"
            @dragenter.prevent="setActive"
            @dragover.prevent="setActive"
            @dragleave.prevent="setInactive"
            @drop.prevent="onDrop"
            @click="chooseFiles"
        >
            <input
                ref="fileInput"
                class="hidden"
                type="file"
                :accept="accept"
                :multiple="multiple"
                :dusk="duskSelector"
                @change="selectFiles"
            >
            <div
                v-if="displayPreview"
                class="order-2 filepreview"
            >
                <slot name="preview">
                    <ul v-if="files.length > 0">
                        <li
                            v-for="(file, index) in files"
                            :key="index"
                        >
                            <div class="flex items-center w-full">
                                <div
                                    v-if="accept === 'image/*'"
                                    class="flex-auto min-w-0"
                                    :data-type="file.type"
                                >
                                    <img
                                        :src="showImage(file)"
                                        :alt="file.name"
                                        class="flex-auto max-w-full max-h-[300px] pointer-events-none"
                                    >
                                </div>
                                <div
                                    v-else
                                    class="flex flex-auto items-center min-w-0"
                                >
                                    <i class="text-3xl fas fa-file-upload" />
                                    <span class="flex-auto px-5 truncate">{{
                                        file.name
                                    }}</span>
                                </div>
                                <button
                                    class="flex relative z-10 flex-none justify-center items-center w-8 min-w-8 h-8 text-rss-button-blue-800 hover:text-white hover:bg-rss-button-red rounded transition"
                                    @click.prevent="removeFile($event, index)"
                                >
                                    <i class="text-2xl far fa-times" />
                                </button>
                            </div>
                        </li>
                    </ul>
                </slot>
            </div>
            <slot name="drag-area">
                <div
                    v-if="!multiple || files.length < 1"
                    class="flex flex-col justify-center items-center py-10 px-6 w-full text-center text-white bg-spotler-honesty-darker/70 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none file-preview-overlay"
                    :class="[dragAreaClasses, { 'opacity-100': files.length < 1}]"
                >
                    <i class="text-6xl fas fa-cloud-upload" />
                    <span class="mt-4 text-2xl font-light">Drag and drop your files here</span>
                    <ul class="flex flex-wrap justify-center mt-4 space-x-3">
                        <li
                            v-for="icon in fileIcons"
                            :key="icon"
                        >
                            <i
                                class="text-3xl far"
                                :class="'fa-' + icon"
                            />
                        </li>
                    </ul>
                    <span class="my-4">OR</span>
                    <BlueButton button-classes="text-xs bg-spotler-honesty-darker group-hover:bg-rss-button-blue-800">
                        Select Files To Upload
                    </BlueButton>
                </div>
            </slot>
        </div>
        <div v-if="displayErrors && fileErrors.length > 0">
            <ul>
                <li
                    v-for="(item, index) in fileErrors"
                    :key="index"
                >
                    <ErrorMessage>
                        {{ item.name }} could not be added due to an incorrect
                        file type.
                    </ErrorMessage>
                </li>
            </ul>
        </div>
    </div>
</template>
